import React from "react";
import { useSelector } from "react-redux";
import { ResponsiveAppBar } from "../../../components-old/ComponentsIndex";
import { RouteGuardContextProvider } from "../../../context/RouteGuardContext";
import { selectUser } from "../../../store/store-selector";
import RouteGuard from "../route-guard/RouteGuard";
import { FormContainer, ControlContainer } from "./style.module";

const AppFormRootContainer = ({ children }) => {
  const user = useSelector(selectUser);
  return (
    <RouteGuardContextProvider>
      <ResponsiveAppBar avatarUrl={user.userRecord.photoURL} />
      <FormContainer
        containerstyle={{
          height: "calc(100vh - 20px - 0px - 64px)",
          marginTop: "20px",
          paddingTop: "64px",
          paddingLeft: "55px",
        }}
      >
        <ControlContainer>{children}</ControlContainer>
      </FormContainer>
      <RouteGuard />
    </RouteGuardContextProvider>
  );
};

export default AppFormRootContainer;
